(() => {
  'use strict';
  const root = document.querySelector('[data-nt-testimonials]');
  if (!root) return;
  const slides = [...root.querySelectorAll('[data-slide]')];
  const dots = [...root.querySelectorAll('[data-dot]')];
  if (slides.length === 0) return;

  let current = 0;

  function show(idx) {
    current = ((idx % slides.length) + slides.length) % slides.length;
    slides.forEach((s, i) => s.classList.toggle('is-active', i === current));
    dots.forEach((d, i) => d.setAttribute('aria-selected', i === current ? 'true' : 'false'));
  }

  dots.forEach(d => d.addEventListener('click', () => show(Number(d.dataset.dot))));
  root.querySelector('[data-test-next]')?.addEventListener('click', () => show(current + 1));
  root.querySelector('[data-test-prev]')?.addEventListener('click', () => show(current - 1));

  // Disclaimer modal
  const modal = document.querySelector('[data-nt-modal]');
  if (modal) {
    document.querySelectorAll('[data-nt-modal-open]').forEach(b => {
      b.addEventListener('click', e => { e.preventDefault(); modal.classList.add('is-open'); });
    });
    modal.addEventListener('click', e => {
      if (e.target === modal || e.target.closest('[data-nt-modal-close]')) {
        modal.classList.remove('is-open');
      }
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') modal.classList.remove('is-open');
    });
  }
})();
